import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'configuration-commitments-tab-2-part',
	standalone: true,
	templateUrl: './configuration-commitments-tab-2.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./configuration-commitments-tab-2.part.scss`],
})
export class ConfigurationCommitmentsTab2Part {
}
